import React from "react";
import Box from "@mui/material/Box";

import { TVehicle } from "types";

import { getBackdropPicture } from "./helper";

interface IBackdrop {
  vehicle: TVehicle;
}
const Backdrop: React.FC<IBackdrop> = ({ vehicle }): JSX.Element | null => {
  const backdropPicture = getBackdropPicture(vehicle);
  if (!backdropPicture) return null;

  return (
    <Box
      sx={{
        backgroundImage: `url(${backdropPicture})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        width: "100vw",
        height: "100vh",
        position: "fixed",
        left: 0,
        filter: "blur(10px)",
        opacity: 0.2,
        zIndex: -1,
      }}
    />
  );
};

export default Backdrop;
